<osp-dialog>
  <ng-template ospTemplate="content">
    @if (message) {
      <p class="osp-confirm-dialog__message" [innerHtml]="message"></p>
    }
  </ng-template>
  <ng-template ospTemplate="footer">
    <osp-button category="secondary" [label]="rejectLabel" [icon]="rejectIcon" (onClick)="reject()" />
    <osp-button
      #acceptButton
      [category]="acceptCategory"
      [label]="acceptLabel"
      [icon]="acceptIcon"
      (onClick)="accept()"
    />
  </ng-template>
</osp-dialog>
